export default __webpack_public_path__ + "static/media/la_ferte-vidame03.43fa9e0a.jpg";